import { useDispatch } from 'react-redux';
import { Link } from 'react-router';

import { REFERRAL_DISCOUNT_AMOUNT, REFERRAL_REWARD_AMOUNT } from 'my-core/constants';
import { useCurrentUser } from 'my-core/hooks';
import { invitesPagePath } from 'my-core/routes';
import { numberToCurrency } from 'my-utils';

import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { addErrorMessage, addMessage } from 'my-actions/MessageActions';

export default function StudySessionCardReferral() {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();

  function copyReferralCode() {
    const referralCode = `${window.location.origin}${window.location.pathname}?ref=${currentUser.gid}`;
    window.navigator?.clipboard?.writeText(referralCode).then(
      () =>
        dispatch(
          addMessage({
            content: 'Link copied to clipboard',
            duration: 2000,
          }),
        ),
      () =>
        dispatch(
          addErrorMessage({
            content: 'Link copy failed',
            duration: 2000,
          }),
        ),
    );
  }

  return (
    <div>
      <Divider sx={{ my: 2 }} />
      <Typography gutterBottom variant="body1">
        <strong>
          Give {numberToCurrency(REFERRAL_DISCOUNT_AMOUNT)} & Get {numberToCurrency(REFERRAL_REWARD_AMOUNT)} | Refer
          Your Friends to Wizeprep Live Prep!
        </strong>
      </Typography>
      <Typography gutterBottom variant="body1">
        Tell your friends about Wizeprep Live Exam Prep and earn {numberToCurrency(REFERRAL_REWARD_AMOUNT)} per
        referral.
      </Typography>
      <Button
        onClick={copyReferralCode}
        startIcon={<FontAwesomeIcon icon={faCopy} />}
        sx={{ mr: 1, mt: 1 }}
        variant="contained"
      >
        Copy Referral Link
      </Button>
      <Button component={Link} nativeButton={false} sx={{ mt: 1 }} to={invitesPagePath()} variant="outlined">
        Learn More
      </Button>
    </div>
  );
}
